var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOthergender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 337.02 340.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5d7182;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123,106.84c-8.55,22.68-1.29,52.69,16.68,69,7.85,7.11,16.72,10.68,25.55,10.71V77.36C145.73,77.59,129.88,88.56,123,106.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150,191.76a8.17,8.17,0,0,0-6.85-.46c-28.87,9.75-50.28,33.56-51.82,62.74-.34,6.44,2,9,8.76,9q34.92,0,69.85,0V197.55A47.4,47.4,0,0,1,150,191.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.25,248c-5-28.29-21.9-46.56-48.25-56.75a7.08,7.08,0,0,0-6.42.5,42,42,0,0,1-20.65,5.83v65.47q34.19,0,68.38,0c5.22,0,7.52-2.39,7.42-7.58A48.78,48.78,0,0,0,245.25,248Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.83,109.17c3.76-3.26,6.52-3.14,10.14.25a33,33,0,0,1,8.65,12.47c7.28,19.1,3.72,36.55-8.2,52.7-.83,1.12-2.24,1.92-2.42,3.44,10.49.58,18.86,6.08,27.64,10.88a14.3,14.3,0,0,0,.77-1.74,276.8,276.8,0,0,0,7.48-37.61c1.09-8.18,1.6-16.39-.23-24.54-6.43-28.67-30.58-47.59-58.73-47.66V120A105.33,105.33,0,0,0,184.83,109.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthergender);
export default __webpack_public_path__ + "static/media/othergender.96e3031b6d6e6978523c9879d9cf70e3.svg";
export { ForwardRef as ReactComponent };